import React, { useContext, useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { getRequest, deleteRequest, tabulatorGet, fetchTextGet, downloadBlobGet } from '../../../api/ApiController';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import '../../../assets/css/style.css';
import '../../../assets/css/iconsmenu.css'
import { Dialog } from 'primereact/dialog';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon,EditRowIcon, CollapseTreeIcon, ExpandTreeIcon, BranchTreeIcon,PaperClipIcon} from "../../svg/svgIcons";
import UtilContext from '../../../components/UtilContext';
import AuthContext from '../../../components/AuthContext';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import ReactDOMServer from 'react-dom/server';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../../utils/tabulatorScroll';
import { getModuleSettingValue, getCalSemaforColor, getSemaforColorClass } from '../../../utils/moduleSettings';
import { getDateFormat } from '../../../utils/dateUtils';
import { asRowList, formatTreeValidityLabel, protocolFileList } from '../../../utils/otkCompanyCertTabulatorCells';
import { getTabulatorPersistLayoutEvents } from '../../../utils/tabulatorPersistLayout';
import { extractSafePaginationParams, createDedupedAjaxRequest, cleanSorters } from '../../../utils/tabulatorProgressiveLoading';
import { getPusherChannel } from '../../../utils/pusherChannel';
import { LocaleContext } from '../../../components/LocaleContext';
import { inputOnEnterHeaderFilter } from '../../../utils/inputOnEnterHeaderFilter';
import { buildTabulatorIdColumn } from '../../../utils/tabulatorIdColumn';
import { TABULATOR_AUDIT_MIN_ROW_HEIGHT, TABULATOR_AUDIT_PROFILES, buildAuditTabulatorColumns } from '../../../utils/tabulatorAuditColumns';
import { buildExportQueryStringFromParams, openPrintHtmlWindow, triggerBlobDownload } from '../../../utils/serviceTaskExport';
import { EXPORT_DOCUMENT_TITLE_KEYS, xlsxDownloadFilename } from '../../../utils/exportExcelNaming';
import { applyTabulatorRuntimeI18n } from '../../../utils/tabulatorRuntimeI18n';
import {
  SESSION_SAFE_UPDATE,
  SESSION_TOMBSTONE,
  CALIBRATION_COMPANY_CERT_KIND,
  CALIBRATION_COMPANY_CERT_STATE_UPDATED_EVENT,
  applyCalibrationCertPagedMutationOverlay,
  classifyCalibrationCompanyCertStateMutation,
  collectCalibrationCompanyCertChangedFields,
  decorateCalibrationCertTreeRows,
  mapCalibrationCompanyCertHeaderFiltersToQuery,
  mapCalibrationCompanyCertSorterField,
  calibrationCertTreeRowKey,
  resolveCalibrationCertTreeAuditRow,
} from '../../../utils/calibrationCertificateStateSync';
const CALIBRATION_COMPANY_CERT_STATE_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'company.name': 'Calibration.CompanyName',
  'name': 'Calibration.CertificateName',
  'custom_company_status': 'Calibration.CompanyStatus',
  'custom_cert_status': 'Calibration.CertificateStatus',
  'description': 'Calibration.CertificateDescription',
  'custom_start_of_validity': 'Common.ValidFrom',
  'custom_end_of_validity': 'Common.ValidTo',
  'custom_expiration': 'Common.Expiration',
  'record_description': 'Common.ValidityDescription',
  'responsible.name': 'Common.Column.Responsible',
  'required_attachment': 'Common.MandatoryAttachment',
  'company.contact_person': 'Common.ContactPerson',
  'state': 'Common.Status',
  'protocol': 'Common.Protocol',
});



export const CALIBRATION_COMPANY_CERT_STATE_LIST_DEFAULT_COLUMNS_VISIBLE = Object.freeze({
  id: true,
  'company.name': true,
  name: true,
  custom_company_status: true,
  custom_cert_status: true,
  description: true,
  custom_start_of_validity: true,
  custom_end_of_validity: true,
  custom_expiration: true,
  record_description: true,
  'responsible.name': true,
  required_attachment: true,
  'company.contact_person': true,
  protocol: true,
  state: true,
  created_at: true,
  updated_at: true,
});

function toLocalDateString(d) {
  if (!d || !(d instanceof Date) || isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export default function CalibrationCompanyCertStateList({ preview = null, preview_period = null, preview_segment = null }){

    const [state,dispatch] = useContext(DatabaseContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,openFilePreview, openChosenNotificationPreferences, getUserColor, getUserInitials} = useContext(UtilContext);
    const {user} = useContext(AuthContext);
    const { t, locale } = useContext(LocaleContext);

    const [insertIcon,setInsertIcon] = useState(true);
    const [editFormGauge, setEditFormGauge] = useState([]);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [copyIcon,setCopyIcon] = useState(true);
    const [searchIconColor,setSearchIconColor] = useState("");

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [searchValue,setSearchValue] = useState('');
    const [scrollValue,setScrollValue] = useState(1);
    const [markUnmark, setMarkUnmarked] = useState(true);

    const [columnsVisible, setColumnsVisible] = useState(() => ({ ...CALIBRATION_COMPANY_CERT_STATE_LIST_DEFAULT_COLUMNS_VISIBLE }));
    const [tableSessionKey, setTableSessionKey] = useState(0);


    const [maskVisible, setMaskVisible] = useState(false);
const hasAddPermission = user?.permissions?.includes('edit calibration-company');
    const isSingleParentSelected = editFormGauge.length === 1 && editFormGauge[0] && typeof editFormGauge[0]._children !== 'undefined';
    const addButtonDisabled = !hasAddPermission || !isSingleParentSelected;


    const ref = useRef(null);
    const elementRef = useRef(null);
    const tableContainerRef = useRef(null);
    const overlayRef = useRef(null);
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const lastResponseRef = useRef(null);
    const isRestoringRef = useRef(false);
    const pendingInvalidationRef = useRef(false);
    const mutationOverlayRef = useRef(new Map());
    const listMountedRef = useRef(true);
    const restartQueuedRef = useRef(false);
    const ajaxGenerationRef = useRef(0);
    const showGenerationRef = useRef(0);
    const confirmedQueryRef = useRef({ filters: [], sorters: [] });
    const sessionQueryActiveRef = useRef(false);
    const lastContainerHeightRef = useRef(0);
    const expandedParentIdsRef = useRef(new Set());
    const toolbarSearchRef = useRef('');
    const tableBuiltRef = useRef(false);
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const isTableVisible = useCallback(() => {
      const el = tableContainerRef.current;
      if (el && el.offsetParent != null && el.clientHeight > 0) return true;
      const table = getTable();
      const tel = table?.getElement?.() ?? table?.element;
      return !!(tel && tel.offsetParent != null && tel.clientHeight > 0);
    }, [getTable]);

    const captureHScroll = useCallback(() => {
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      if (!holder) return;
      savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);

    const restoreHScroll = useCallback(() => {
      if (!savedHScrollRef.current.pending) return;
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      const header = table.columnManager?.contentsElement;
      if (!holder) return;
      const left = savedHScrollRef.current.left;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          holder.scrollLeft = left;
          if (header) header.scrollLeft = left;
          savedHScrollRef.current.pending = false;
        });
      });
    }, [getTable]);

    const module_settings = state.module_settings || [];
    const dateFmt = getDateFormat(module_settings);
    const dateTimeFmt = `${dateFmt} HH:mm`;
    const showExcludedPartnersByState = getModuleSettingValue(module_settings, 'calibration', 'show_excluded_calibration_companies_list_by_state', '0');
    const showDeactivatedDocsByState = getModuleSettingValue(module_settings, 'calibration', 'show_deactivated_certs_list_by_state', '0');
    const pageSizePc = useMemo(() => {
      const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
      const n = parseInt(v, 10);
      return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);

    const snapshotConfirmedQuery = useCallback(() => {
      const table = getTable();
      confirmedQueryRef.current = {
        filters: table?.getHeaderFilters?.() ?? [],
        sorters: cleanSorters(table?.getSorters?.() || []),
      };
    }, [getTable]);

    const restartFullProgressiveSession = useCallback(() => {
      if (!listMountedRef.current || restartQueuedRef.current) return;
      snapshotConfirmedQuery();
      sessionQueryActiveRef.current = true;
      ajaxGenerationRef.current += 1;
      showGenerationRef.current += 1;
      pendingInvalidationRef.current = false;
      mutationOverlayRef.current = new Map();
      expandedParentIdsRef.current = new Set();
      tableBuiltRef.current = false;
      restartQueuedRef.current = true;
      completedCacheRef.current.clear();
      lastResponseRef.current = null;
      inFlightRef.current = { sig: null, promise: null };
      isRestoringRef.current = true;
      const table = getTable();
      if (typeof table?.destroy === 'function') table.destroy();
      ref.current = null;
      setTableSessionKey((key) => key + 1);
    }, [getTable, snapshotConfirmedQuery]);

    const requestFullProgressiveSessionRestart = useCallback(() => {
      if (!listMountedRef.current) return;
      if (!isTableVisible()) {
        pendingInvalidationRef.current = true;
        return;
      }
      restartFullProgressiveSession();
    }, [isTableVisible, restartFullProgressiveSession]);

    const getLoadedRowComponent = useCallback((id) => {
      const table = getTable();
      if (!table || typeof table.getRow !== 'function' || id == null || id === '') return null;
      try {
        const row = table.getRow(calibrationCertTreeRowKey({ id }, false));
        return row && row !== false ? row : null;
      } catch (_e) {
        try {
          const row = table.getRow(id);
          return row && row !== false ? row : null;
        } catch (_err) {
          return null;
        }
      }
    }, [getTable]);

    const applySafeCompanyCertPatch = useCallback((canonicalRow) => {
      const id = canonicalRow?.id;
      const rowComponent = getLoadedRowComponent(id);
      if (!rowComponent || typeof rowComponent.update !== 'function' || !canonicalRow) {
        requestFullProgressiveSessionRestart();
        return;
      }
      const decorated = decorateCalibrationCertTreeRows([canonicalRow])[0];
      rowComponent.update(decorated);
      mutationOverlayRef.current.set(String(id), decorated);
      if (expandedParentIdsRef.current.has(Number(id)) && typeof rowComponent.treeExpand === 'function') {
        rowComponent.treeExpand();
      }
    }, [getLoadedRowComponent, requestFullProgressiveSessionRestart]);

    const sessionContext = useCallback(() => {
      const table = getTable();
      return {
        toolbarSearch: toolbarSearchRef.current,
        activeHeaderFilters: table?.getHeaderFilters?.() ?? [],
        activeSorters: cleanSorters(table?.getSorters?.() || []),
        isRowLoaded: (rid) => Boolean(getLoadedRowComponent(rid)),
      };
    }, [getTable, getLoadedRowComponent]);

    const fetchCanonicalParent = useCallback((id, generation) => {
      return getRequest(`/api/company_certificates/${id}`).then((res) => {
        if (generation !== showGenerationRef.current) return null;
        if (mutationOverlayRef.current.get(String(id)) === SESSION_TOMBSTONE) return null;
        return res?.data?.data ?? res?.data ?? res;
      });
    }, []);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
      const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
      if (extra.size == null) extra.size = pageSizePc;
      extra.type = 'calibration';
      extra.show_excluded_companies = showExcludedPartnersByState;
      extra.show_deactivated_certs = showDeactivatedDocsByState;
      if (preview_period?.dateFrom != null) {
        const dFrom = preview_period.dateFrom instanceof Date ? preview_period.dateFrom : new Date(preview_period.dateFrom);
        const s = toLocalDateString(dFrom);
        if (s) extra.date_from = s;
      }
      if (preview_period?.dateTo != null) {
        const dTo = preview_period.dateTo instanceof Date ? preview_period.dateTo : new Date(preview_period.dateTo);
        const s = toLocalDateString(dTo);
        if (s) extra.date_to = s;
      }
      if (preview_segment != null && preview_segment !== '') extra.preview_segment = preview_segment;
      const rawSorters = sessionQueryActiveRef.current
        ? (confirmedQueryRef.current.sorters || [])
        : cleanSorters(paramsFromTabulator?.sorters ?? getTable()?.getSorters?.() ?? []);
      const mapped = rawSorters
        .map((s) => {
          const field = mapCalibrationCompanyCertSorterField(s?.field || s?.column);
          if (!field) return null;
          return { field, dir: s?.dir === 'desc' ? 'desc' : 'asc' };
        })
        .filter(Boolean);
      if (mapped.length) extra.sorters = JSON.stringify(mapped);
      const hf = sessionQueryActiveRef.current
        ? (confirmedQueryRef.current.filters || [])
        : (getTable()?.getHeaderFilters?.() ?? []);
      Object.assign(extra, mapCalibrationCompanyCertHeaderFiltersToQuery(hf));
      const search = String(toolbarSearchRef.current ?? '').trim();
      if (search !== '') extra.toolbar_search = search;
      return extra;
    }, [pageSizePc, showExcludedPartnersByState, showDeactivatedDocsByState, preview_period, preview_segment, getTable]);

    const fetchCompanyCertPaged = useCallback((url, merged) => {
      return tabulatorGet(url, merged).then((r) => {
        const decorated = decorateCalibrationCertTreeRows(r?.data ?? []);
        // Optional bucket preview (after/15/30/others) stays client-only over loaded parents.
        // Period/segment previews are server-authoritative via date_from/date_to/preview_segment.
        const data = preview == null
          ? decorated
          : decorated.filter((row) => previewFilter(row, { time_period: preview }));
        return {
          data,
          last_page: r?.last_page ?? 1,
          total: r?.total ?? 0,
          current_page: r?.current_page ?? merged?.page ?? 1,
        };
      });
    }, [preview]);

    const ajaxRequestFunc = useCallback((url, config, params) => {
      const generation = ajaxGenerationRef.current;
      if (pendingInvalidationRef.current && !isTableVisible()) {
        return Promise.resolve({ data: [], last_page: 1, current_page: Number(params?.page) || 1, total: 0 });
      }
      return createDedupedAjaxRequest(
        buildRequestParams,
        fetchCompanyCertPaged,
        inFlightRef,
        completedCacheRef,
        isRestoringRef,
        lastResponseRef,
      )(url, config, params).then((data) => {
        if (generation !== ajaxGenerationRef.current) {
          return { data: [], last_page: data?.last_page ?? 1, total: 0, current_page: Number(params?.page) || 1 };
        }
        return data;
      });
    }, [buildRequestParams, fetchCompanyCertPaged, isTableVisible]);

    useEffect(() => {
      listMountedRef.current = true;
      return () => { listMountedRef.current = false; };
    }, []);

    useEffect(() => {
      const el = tableContainerRef.current;
      if (!el || typeof ResizeObserver === 'undefined') return;
      const ro = new ResizeObserver(() => {
        const h = el.clientHeight;
        const visible = h > 0 || isTableVisible();
        if (visible) {
          const wasHidden = lastContainerHeightRef.current <= 0;
          lastContainerHeightRef.current = Math.max(h, 1);
          if (pendingInvalidationRef.current) {
            requestAnimationFrame(() => restartFullProgressiveSession());
          } else if (wasHidden) {
            requestAnimationFrame(() => getTable()?.redraw?.(true));
          }
        } else {
          lastContainerHeightRef.current = 0;
        }
      });
      ro.observe(el);
      return () => ro.disconnect();
    }, [getTable, isTableVisible, restartFullProgressiveSession]);

    const getPrintColumnsOrder = useCallback(() => {
      const table = getTable();
      const allowed = Object.keys(CALIBRATION_COMPANY_CERT_STATE_LIST_DEFAULT_COLUMNS_VISIBLE);
      const fallback = () => allowed.filter((f) => columnsVisible[f] !== false);
      if (!table?.getColumns) return fallback();
      const allowedSet = new Set(allowed);
      const out = [];
      const seen = new Set();
      try {
        table.getColumns().forEach((col) => {
          const field = col.getField?.() ?? col.getDefinition?.()?.field;
          if (!field || !allowedSet.has(field)) return;
          if (columnsVisible[field] === false) return;
          if (seen.has(field)) return;
          seen.add(field);
          out.push(field);
        });
      } catch (_e) {
        return fallback();
      }
      return out.length > 0 ? out : fallback();
    }, [getTable, columnsVisible]);

    const buildCompanyCertExportQueryString = useCallback((opts = {}) => {
      const extra = buildRequestParams({});
      return buildExportQueryStringFromParams(extra, opts);
    }, [buildRequestParams]);

    const runCompanyCertPrint = useCallback(async () => {
      try {
        setDialogText?.(t('Common.PreparingPrint'));
        setVisible?.(true);
        const suffix = buildCompanyCertExportQueryString({
          includePrintColumns: true,
          printColumns: getPrintColumnsOrder(),
        });
        const html = await fetchTextGet(`/api/company_certificates/export/print${suffix}`);
        if (!openPrintHtmlWindow(html)) {
          toast?.current?.show({ severity: 'warn', summary: t('DepartmentList.Toast.PrintTitle'), detail: t('Common.EnablePopups'), life: 4000 });
        }
      } catch (e) {
        toast?.current?.show({ severity: 'error', summary: t('DepartmentList.Toast.PrintTitle'), detail: e?.message || t('Common.PrintFailed'), life: 4500 });
      } finally {
        setVisible?.(false);
      }
    }, [buildCompanyCertExportQueryString, getPrintColumnsOrder, setDialogText, setVisible, t, toast]);

    const exportCompanyCertXlsx = useCallback(async () => {
      try {
        setDialogText?.(t('Common.PreparingExport'));
        setVisible?.(true);
        const suffix = buildCompanyCertExportQueryString({
          includePrintColumns: true,
          printColumns: getPrintColumnsOrder(),
        });
        const { blob, filename } = await downloadBlobGet(`/api/company_certificates/export/xlsx${suffix}`, xlsxDownloadFilename(t(EXPORT_DOCUMENT_TITLE_KEYS.CALIBRATION_COMPANY_CERT_STATE)));
        triggerBlobDownload(blob, filename || xlsxDownloadFilename(t(EXPORT_DOCUMENT_TITLE_KEYS.CALIBRATION_COMPANY_CERT_STATE)));
      } catch (e) {
        toast?.current?.show({ severity: 'error', summary: t('Common.Export'), detail: e?.message || t('Common.ExportFailed'), life: 4500 });
      } finally {
        setVisible?.(false);
      }
    }, [buildCompanyCertExportQueryString, getPrintColumnsOrder, setDialogText, setVisible, t, toast]);

      function searchTable(){
        setSearchIconColor("active");
        if (searchValue === " ") setSearchValue("");
        toolbarSearchRef.current = String(searchValue === " " ? "" : searchValue).trim();
        setVisibleSearch(false);
        captureHScroll();
        requestFullProgressiveSessionRestart();
      }


      const onSelectRow = (data, rows) => {
        setEditFormGauge(data);
          if(data.length === 0){
            setInsertIcon(true);
            setEditIcon(true);
            setCopyIcon(true);
            setDeleteIcon(true);
          }
          else{
            setInsertIcon(false);
            setEditIcon(false);
            setCopyIcon(false);
            setDeleteIcon(false);
          }
      };
      function CalibrationCompanyNameFormatter(props) {
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(rowData?._children) return <div className='training_name'>{rowData.company.name}</div>;
        return "";
      }

      function NameFormatter(props) {
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(rowData?._children) return <div className='training_name'>{rowData.name}</div>;
        if(parent){
            let parent_array = asRowList(parent._row?.data?._children);
            for(let i = 0;i<parent_array.length;i++){
                if(parent_array[i].id == rowData.id){
                    if(i==parent_array.length-1)return <div className='training_name'>Prvotný certifikát</div>;
                    else return <div className='training_name'>{parent_array.length-1-i}. Opakovaný certifikát</div>;
                }
            }
            return <div className='training_name'>{parent._row.data.name}</div>;
        }
        return "";
      }

      function CertDescriptionFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?._children) return <div className='training_name'>{rowData.description}</div>;
        return "";
      }

      function RequiredAttachmentFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const parent = props.cell.getRow()?.getTreeParent();
        const value = rowData?.required_attachment ?? parent?._row?.data?.required_attachment;
        return <span className='training_name'>{value ? t('Common.Yes') : t('Common.No')}</span>;
      }

      function RecordDescriptionFormatter(props) {
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(rowData?._children) return <div className='training_name'>{asRowList(rowData?._children)[0]?.description}</div>;
        if(parent){
            return <div className='training_name'>{rowData?.description}</div>;
        }
        return "";
      }

      function viewFile(file_id){
          getRequest(`/api/company_cert_records/protocol/${file_id}`).then((response) => {
              if (response?.data?.url) openFilePreview({ url: response.data.url, filename: response.data.filename });
          });
      }

        function Protocol(props) {
          const rowData = props.cell.getRow().getData();
          const files = protocolFileList(rowData);
          if (!files.length) return "";
          return <div className='flex flex-row'>{files.map((img) => (<a style={{color:'blue',cursor:'pointer',marginBottom:'2px',width: '24px',display: 'block'}} onClick={() => {viewFile(img.id);}}><PaperClipIcon/></a>))}</div>;
      }

      function EndOfValidity(props){
          const rowData = props.cell.getRow().getData();
          const label = formatTreeValidityLabel(rowData, 'end_of_validity', dateFmt);
          if (label) return label;
          return <span className='text-red-500'>{t('Ui.R67.Necertifikovane')}</span>;
      }

      function StartOfValidity(props){
          const rowData = props.cell.getRow().getData();
          const label = formatTreeValidityLabel(rowData, 'start_of_validity', dateFmt);
          if (label) return label;
          return <span className='text-red-500'>{t('Ui.R67.Necertifikovane')}</span>;
      }

      function StateFormatter(props){
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(parent){
            let parent_array = asRowList(parent._row?.data?._children);
            for(let i = 0;i<parent_array.length;i++){
                if(parent_array[i].id == rowData.id){
                    if(i==parent_array.length-1){
                        if(new Date(parent_array[i]?.end_of_validity) < new Date()){
                            return "NOK";
                        }
                        else return "OK";
                    }
                    else return "OK";
                }
            }
        }
        const kids = asRowList(rowData?._children);
        if(kids.length > 0){
            if(new Date(kids[0]?.end_of_validity) < new Date()){
                return "NOK";
            }
            return "OK"
        }
        else return "NOK";
      }

      function CompanyStatusFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const v = rowData?.company?.validity;
        if (v == 1 || v === '1') return <div className="training_name">Aktívny</div>;
        return <div className="training_name">Vyradený</div>;
      }

      function CertStatusFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const v = rowData?.deactivation_date;
        return <div className="training_name">{v ? t('Status.Deactivated') : t('Status.Active')}</div>;
      }

      function companyStatusHeaderFilter(headerValue, rowValue, rowData) {
        const v = rowData?.company?.validity;
        const isActive = v == 1 || v === '1';
        if (headerValue === 'Aktívny') return isActive;
        if (headerValue === 'Vyradený') return !isActive;
        return false;
      }

      function certStatusHeaderFilter(headerValue, rowValue, rowData) {
        const v = rowData?.deactivation_date;
        const isActive = !v;
        if (headerValue === 'Aktívny') return isActive;
        if (headerValue === 'Deaktivovaný') return !isActive;
        return false;
      }

      function getExpirationBucket(endDate, rowData) {
        const isDeactivated = rowData?.deactivation_date || (asRowList(rowData?._children)[0]?.deactivation_date);
        if (isDeactivated) return "DEA";
        if (!endDate) return "0-";
        const now = new Date();
        if (endDate < now) return "0-";
        const daysLeft = Math.ceil((endDate - now) / (1000 * 60 * 60 * 24));
        if (daysLeft <= 15) return "15-";
        if (daysLeft <= 30) return "30-";
        if (daysLeft <= 45) return "45-";
        if (daysLeft <= 60) return "60-";
        return "61+";
      }

      function expirationHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        if (headerValue === 'Všetky' || headerValue === '') return true;
        let endDate = null;
        if (rowData?.end_of_validity) {
          endDate = new Date(rowData.end_of_validity);
        } else if (asRowList(rowData?._children).length > 0) {
          endDate = new Date(asRowList(rowData._children)[0].end_of_validity);
        }
        const state = getExpirationBucket(endDate, rowData);
        return headerValue === state;
      }

      function ExpirationFormatter(props) {
        const rowData = props.cell.getRow().getData();
        let endDate = null;
        if (rowData?.end_of_validity) {
          endDate = new Date(rowData.end_of_validity);
        } else if (asRowList(rowData?._children).length > 0) {
          endDate = new Date(asRowList(rowData._children)[0].end_of_validity);
        }
        const bucket = getExpirationBucket(endDate, rowData);
        const color = getCalSemaforColor(module_settings, bucket);
        const colorClass = getSemaforColorClass(color);
        return (
          <span className="inline-flex items-center gap-1.5">
            <span className={`inline-block w-2.5 h-2.5 rounded-full shrink-0 ${colorClass}`} title={bucket} />
            <span>{bucket}</span>
          </span>
        );
      }

      const EXPIRATION_FILTER_VALUES = {[t('Common.All')]:t('Common.All'),"61+":"61+","60-":"60-","45-":"45-","30-":"30-","15-":"15-","0-":"0-","DEA":"DEA"};

      const enterInput = { headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false };
      const createdTitle = t('CalibrationCompanyCertStateList.Column.CreatedAt');
      const updatedTitle = t('CalibrationCompanyCertStateList.Column.UpdatedAt');
      const auditTailColumns = useMemo(
        () => buildAuditTabulatorColumns({
          profile: TABULATOR_AUDIT_PROFILES.createdByUpdatedBy,
          includeId: false,
          dateFormat: dateFmt,
          dateTimeFormat: dateTimeFmt,
          getUserColor,
          getUserInitials,
          remotePassthrough: true,
          auditSourceFn: resolveCalibrationCertTreeAuditRow,
        }).map((col) => (col.field === 'created_at' ? { ...col, title: createdTitle } : col.field === 'updated_at' ? { ...col, title: updatedTitle } : col)),
        [dateFmt, dateTimeFmt, getUserColor, getUserInitials, createdTitle, updatedTitle]
      );

      const baseColumns = useMemo(() => [
        {
          formatter: 'rowSelection',
          titleFormatter: 'rowSelection',
          titleFormatterParams: { rowRange: 'active' },
          hozAlign: 'center',
          width: 44,
          headerSort: false,
          resizable: false,
          frozen: true,
          cellClick: function (e, cell) {
            cell.getRow().toggleSelect();
          },
        },
        buildTabulatorIdColumn({ frozen: true, extra: { title: t('CalibrationCompanyCertStateList.Column.Id', 'ID') } }),
        { title: t('Calibration.CompanyName'), field: 'company.name', formatter: reactFormatter(<CalibrationCompanyNameFormatter/>), ...enterInput, width: 220, minWidth: 220, widthGrow: 1 },
        { title: t('Calibration.CertificateName'), field: 'name', formatter: reactFormatter(<NameFormatter/>), ...enterInput, width: 220, minWidth: 220, widthGrow:1 },
        { title: t('Calibration.CompanyStatus'), field: 'custom_company_status', headerFilter:"list", headerFilterLiveFilter: false, headerFilterParams:{values:{[t('Status.Active')]:t('Status.Active'),[t('Status.Excluded')]:t('Status.Excluded')}, clearable:true}, width: 220, minWidth: 220, widthGrow:1, formatter: reactFormatter(<CompanyStatusFormatter/>) },
        { title: t('Calibration.CertificateStatus'), field: 'custom_cert_status', headerFilter:"list", headerFilterLiveFilter: false, headerFilterParams:{values:{[t('Status.Active')]:t('Status.Active'),[t('Status.Deactivated')]:t('Status.Deactivated')}, clearable:true}, width: 260, minWidth: 260, widthGrow:1, formatter: reactFormatter(<CertStatusFormatter/>) },
        { title: t('Calibration.CertificateDescription'), field: 'description', formatter: reactFormatter(<CertDescriptionFormatter/>), ...enterInput, width: 220, minWidth: 220, widthGrow:1 },
        { title: t('Common.ValidFrom'), field: 'custom_start_of_validity', ...enterInput, width: 200, minWidth: 200, widthGrow:1, formatter: reactFormatter(<StartOfValidity/>) },
        { title: t('Common.ValidTo'), field: 'custom_end_of_validity', ...enterInput, width: 200, minWidth: 200, widthGrow:1, formatter: reactFormatter(<EndOfValidity/>) },
        { title: t('Common.Expiration'), field: 'custom_expiration', headerFilter:"list", headerFilterLiveFilter: false, headerFilterParams:{values:EXPIRATION_FILTER_VALUES, clearable:true}, headerSort: false, width: 150, minWidth: 150, widthGrow:1, formatter: reactFormatter(<ExpirationFormatter/>) },
        { title: t('Common.ValidityDescription'), field: 'record_description', formatter: reactFormatter(<RecordDescriptionFormatter/>), ...enterInput, width: 200, minWidth: 200, widthGrow:1 },
        { title: t('Common.Column.Responsible'), field: 'responsible.name', ...enterInput, width: 260, minWidth: 260, widthGrow:1 },
        { title: t('Common.MandatoryAttachment'), field: 'required_attachment', headerFilter:"list", headerFilterLiveFilter: false, headerFilterParams:{values:{["Áno"]: t('Common.Yes'),["Nie"]: t('Common.No')}, clearable:true}, headerSort: false, width: 200, minWidth: 200, widthGrow:1, formatter: reactFormatter(<RequiredAttachmentFormatter/>) },
        { title: t('Common.ContactPerson'), field: 'company.contact_person', ...enterInput, width: 220, minWidth: 220, widthGrow:1 },
        { title: t('Common.Status'), field: 'state', formatter: reactFormatter(<StateFormatter/>), ...enterInput, width: 200, minWidth: 200, widthGrow:1 },
        { title: t('Common.Protocol'), field: 'protocol', ...enterInput, width: 200, minWidth: 200, widthGrow:1, formatter: reactFormatter(<Protocol/>) },
      ], [t]);
      const columns = useMemo(() => [...baseColumns, ...auditTailColumns], [baseColumns, auditTailColumns]);

    const scrollToFirst = () => scrollToFirstUtil(getTable());
    const scrollUp = () => scrollUpUtil(getTable());
    const scrollDown = () => scrollDownUtil(getTable());
    const scrollToLast = () => scrollToLastUtil(getTable());

    const openAddRecord = () => {
      if (!isSingleParentSelected || !editFormGauge[0]) return;
      const certificate = editFormGauge[0];
      const children = certificate._children || [];
      const lastRecord = children.length
        ? [...children].sort((a, b) => new Date(b.start_of_validity || 0) - new Date(a.start_of_validity || 0))[0]
        : null;
      dispatch({
        type: 'create_new_tab', name: t('Calibration.NewCertRecord'), translationKey: 'Calibration.NewCertRecord', legacyLabel: t('Calibration.NewCertRecord'),
        page: 'CalibrationCompanyCertRecordAdd',
        props: { certificate, lastRecord },
        mask: 'calb012',
      });
    };

    function setMask(item,value){
      const columnVisible = {...columnsVisible};
      columnVisible[item] = value;
      const t = getTable();
      for(const val in columnVisible) {
        if(columnVisible[val]==false) t?.hideColumn?.(val);
        else t?.showColumn?.(val);
      }
      setColumnsVisible(columnVisible);
      setTimeout(() => t?.redraw?.(true), 0);
    }

    const itemRenderer = (item, options) => (
      <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
          <span className={`${item.icon} text-primary`} />
          <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
          {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
      </a>
    );

    const [expandedKeys, setExpandedKeys] = useState({});

    const handleClickOutside = (event) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
          setExpandedKeys({});
      }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: CALIBRATION_COMPANY_CERT_STATE_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);


    // Pusher + same-client: invalidate or canonical parent show patch. Never addData.
    useEffect(() => {
        const channel = getPusherChannel();
        const DEDUPE_MS = 800;
        const lastHandled = { key: '', at: 0 };
        const shouldSkip = (eventType, id) => {
            if (id == null) return true;
            const key = `${eventType}-${id}`;
            const now = Date.now();
            if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
            lastHandled.key = key;
            lastHandled.at = now;
            return false;
        };
        const isCalibration = (p) => p?.type === 'calibration';
        const invalidateSession = () => requestFullProgressiveSessionRestart();
        const refreshCanonicalParent = (id, kind, changedFields) => {
            const previous = (() => {
                try { return getLoadedRowComponent(id)?.getData?.() ?? null; } catch (_e) { return null; }
            })();
            const generation = showGenerationRef.current;
            fetchCanonicalParent(id, generation).then((row) => {
                if (generation !== showGenerationRef.current) return;
                if (mutationOverlayRef.current.get(String(id)) === SESSION_TOMBSTONE) return;
                if (!row?.id) {
                    invalidateSession();
                    return;
                }
                const fields = Array.isArray(changedFields) && changedFields.length
                    ? changedFields
                    : collectCalibrationCompanyCertChangedFields(previous, row, { implicitAudit: true });
                const decision = classifyCalibrationCompanyCertStateMutation({
                    detail: { kind, certificateId: id, changedFields: fields },
                }, sessionContext());
                if (decision === SESSION_SAFE_UPDATE) {
                    applySafeCompanyCertPatch(row);
                    return;
                }
                invalidateSession();
            }).catch(() => invalidateSession());
        };
        const onUpdated = (payload) => {
            if (!isCalibration(payload)) return;
            const id = payload?.id;
            if (id == null || shouldSkip('updated', id)) return;
            refreshCanonicalParent(id, CALIBRATION_COMPANY_CERT_KIND.PARENT_UPDATED);
        };
        const onCreated = (payload) => {
            if (!isCalibration(payload)) return;
            const id = payload?.id;
            if (id == null || shouldSkip('created', id)) return;
            invalidateSession();
        };
        const onDeleted = (payload) => {
            if (!isCalibration(payload)) return;
            const id = payload?.id;
            if (id == null || shouldSkip('deleted', id)) return;
            mutationOverlayRef.current.set(String(id), SESSION_TOMBSTONE);
            try { getLoadedRowComponent(id)?.delete?.(); } catch (_e) {}
            invalidateSession();
        };
        const onActivated = (payload) => {
            if (!isCalibration(payload)) return;
            const id = payload?.id;
            if (id == null || shouldSkip('activated', id)) return;
            invalidateSession();
        };
        const onDeactivated = (payload) => {
            if (!isCalibration(payload)) return;
            const id = payload?.id;
            if (id == null || shouldSkip('deactivated', id)) return;
            invalidateSession();
        };
        const onLocal = (event) => {
            const detail = event?.detail || {};
            const id = detail.certificateId ?? detail.id;
            const kind = detail.kind;
            if (id == null || !kind) return;
            if (kind === CALIBRATION_COMPANY_CERT_KIND.PARENT_DELETED) {
                mutationOverlayRef.current.set(String(id), SESSION_TOMBSTONE);
                try { getLoadedRowComponent(id)?.delete?.(); } catch (_e) {}
            }
            const decision = classifyCalibrationCompanyCertStateMutation(event, sessionContext());
            if (decision === SESSION_SAFE_UPDATE) {
                refreshCanonicalParent(id, kind, detail.changedFields);
                return;
            }
            invalidateSession();
        };
        if (channel) {
            channel.bind('company_certificate.created', onCreated);
            channel.bind('company_certificate.updated', onUpdated);
            channel.bind('company_certificate.deleted', onDeleted);
            channel.bind('company_certificate.activated', onActivated);
            channel.bind('company_certificate.deactivated', onDeactivated);
        }
        window.addEventListener(CALIBRATION_COMPANY_CERT_STATE_UPDATED_EVENT, onLocal);
        return () => {
            if (channel) {
                channel.unbind('company_certificate.created', onCreated);
                channel.unbind('company_certificate.updated', onUpdated);
                channel.unbind('company_certificate.deleted', onDeleted);
                channel.unbind('company_certificate.activated', onActivated);
                channel.unbind('company_certificate.deactivated', onDeactivated);
            }
            window.removeEventListener(CALIBRATION_COMPANY_CERT_STATE_UPDATED_EVENT, onLocal);
        };
    }, [applySafeCompanyCertPatch, fetchCanonicalParent, getLoadedRowComponent, requestFullProgressiveSessionRestart, sessionContext]);

    async function resetMask() {
      const PAGE = 'CalibrationCompanyCertStateList';
      const defaultColumnsVisible = { ...CALIBRATION_COMPANY_CERT_STATE_LIST_DEFAULT_COLUMNS_VISIBLE };
      const mask = (state.user_mask_filters || []).find(m => m.page === PAGE);
      const t = getTable();
      if (mask?.id) {
        setDialogText('Resetujem masku');
        setVisible(true);
        try {
          await deleteRequest(`/api/user_mask_filters/${mask.id}`);
          dispatch({ type: 'load_user_mask_filters', newUserMaskFilters: (state.user_mask_filters || []).filter(m => m.page !== PAGE) });
          setColumnsVisible(defaultColumnsVisible);
          if (t) {
            t.clearHeaderFilter?.();
            t.setSort?.([]);
            const defaultLayout = columns.filter(c => c.field).map(c => ({ field: c.field, width: c.width ?? c.minWidth ?? 200 }));
            if (defaultLayout.length > 0) t.setColumnLayout?.(defaultLayout);
            columns.filter(c => c.field).forEach(col => { t.showColumn?.(col.field); });
          }
          toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.MaskReset') });
        } catch (e) {
          console.log(e);
          toast?.current?.show({ severity: 'error', summary: t('Common.Error'), life: 3000, detail: 'Reset masky zlyhal.' });
        }
        setVisible(false);
      } else {
        setColumnsVisible(defaultColumnsVisible);
        if (t) {
          t.clearHeaderFilter?.();
          t.setSort?.([]);
          const defaultLayout = columns.filter(c => c.field).map(c => ({ field: c.field, width: c.width ?? c.minWidth ?? 200 }));
          if (defaultLayout.length > 0) t.setColumnLayout?.(defaultLayout);
          columns.filter(c => c.field).forEach(col => { t.showColumn?.(col.field); });
        }
        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.MaskReset') });
      }
      requestFullProgressiveSessionRestart();
    }

      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
              {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => {setUserMaskFilter("CalibrationCompanyCertStateList","set_filters",null,getTable()?.getHeaderFilters?.() ?? [],null);captureHScroll();requestFullProgressiveSessionRestart();},
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => {setUserMaskFilter("CalibrationCompanyCertStateList","set_filters",null,[],null);getTable()?.clearHeaderFilter?.();captureHScroll();requestFullProgressiveSessionRestart();},
                template: itemRenderer,
            },
            {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => {setUserMaskFilter("CalibrationCompanyCertStateList","set_sorters",null,null,null,getTable()?.getSorters?.() ?? []);OverflowMenuProvider.setVisible(null);setExpandedKeys({});captureHScroll();requestFullProgressiveSessionRestart();},
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => {setUserMaskFilter("CalibrationCompanyCertStateList","set_sorters",null,null,null,[]);getTable()?.setSort?.([]);OverflowMenuProvider.setVisible(null);setExpandedKeys({});captureHScroll();requestFullProgressiveSessionRestart();},
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5b',
                label: t('Common.ResetUserMask'),
                icon: 'pi pi-refresh',
                command: () => {resetMask();OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('CalibrationCompanyCertStateList');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];function changeMarkings(value){
        const columnVisible = {...columnsVisible};
        const t = getTable();
        for(let val in columnVisible) {
          if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
            columnVisible[val]=false;
            t?.hideColumn?.(val);
          }
        };
        setColumnsVisible(columnVisible);
        setTimeout(() => t?.redraw?.(true), 0);
    }

    function previewFilter(data, filterParams){
      const children = asRowList(data?._children);
      const firstEnd = children[0]?.end_of_validity;
      if(filterParams.time_period=="after"){
          if((children.length == 0 || (children.length > 0 && new Date(firstEnd) < new Date()))){
            return true;
          }
      }
      else if(filterParams.time_period=="15"){
          if(children.length > 0 && ((new Date(firstEnd) > new Date()) && (new Date(firstEnd) <= new Date(new Date().setDate(new Date().getDate() + 15))))){
            return true;
          }
      }
      else if(filterParams.time_period=="30"){
          if(children.length > 0 && ((new Date(firstEnd) > new Date()) && (new Date(firstEnd) <= new Date(new Date().setDate(new Date().getDate() + 30))))){
            return true;
          }
      }
      else if(filterParams.time_period=="others"){
        if(children.length > 0 && (new Date(firstEnd) > new Date(new Date().setDate(new Date().getDate() + 30)))){
          return true;
        }
      }
      return false;
    }

    return(
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={addButtonDisabled} onClick={openAddRecord} title={t('Calibration.AddCertRecord')}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button onClick={() => runCompanyCertPrint()}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="search"><button onClick={searchIconColor!="active"? () => {setVisibleSearch(true);}:() => {setSearchIconColor("");setSearchValue("");toolbarSearchRef.current="";captureHScroll();requestFullProgressiveSessionRestart();}}>{searchIconColor == "" ?  <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.Search')}/> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.CancelSearch')}/>}</button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="export"><button onClick={() => exportCompanyCertXlsx()}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button onClick={() => { captureHScroll(); requestFullProgressiveSessionRestart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('CalibrationCompanyCertStateList'),"CalibrationCompanyCertStateList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="fast"><button onClick={() => setFastView("CalibrationCompanyCertStateList",columnsVisible,columns)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
      </div>
      <div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2" >

    <div ref={(node) => { elementRef.current = node; tableContainerRef.current = node; }}>
    <ReactTabulator
      key={`calibration-company-cert-state-${tableSessionKey}-${showExcludedPartnersByState}-${showDeactivatedDocsByState}`}
      onRef={(r) => (ref.current = r.current)}
      className='h-[calc(100vh_-_193px)]'
      columns={columns}
      events={{
        rowSelectionChanged: onSelectRow,
        dataTreeRowExpanded: (row) => {
          const data = row?.getData?.() || {};
          if (data._rowKey ? String(data._rowKey).startsWith('cert-') : Object.prototype.hasOwnProperty.call(data, '_children')) {
            expandedParentIdsRef.current.add(Number(data.id));
          }
        },
        dataTreeRowCollapsed: (row) => {
          const data = row?.getData?.() || {};
          expandedParentIdsRef.current.delete(Number(data.id));
        },
        headerFilterChanged: () => {
          if (isRestoringRef.current) return;
          captureHScroll();
          requestFullProgressiveSessionRestart();
        },
        sortChanged: () => {
          if (isRestoringRef.current) return;
          captureHScroll();
          requestFullProgressiveSessionRestart();
        },
        renderComplete: () => restoreHScroll(),
        tableBuilt: () => {
            const table = getTable();
            const restartRestore = sessionQueryActiveRef.current;
            const restoreConfirmedFilters = () => {
              const confirmedFilters = confirmedQueryRef.current.filters || [];
              confirmedFilters.forEach((f) => {
                if (!f?.field) return;
                table?.setHeaderFilterValue?.(f.field, f.value, true);
              });
              const confirmedSorters = confirmedQueryRef.current.sorters || [];
              if (confirmedSorters.length > 0) {
                table?.setSort?.(confirmedSorters.map((s) => ({ column: s.field, dir: s.dir })));
              }
            };
            const mask = (state.user_mask_filters || []).filter(m => m.page === "CalibrationCompanyCertStateList");
            const safeParse = (v, fallback) => {
                if (v === null || v === undefined) return fallback;
                if (typeof v === "string") {
                try { return JSON.parse(v); } catch { return fallback; }
                }
                return v;
            };
            if (mask.length > 0 && !preview && !preview_period) {
                const attributes  = safeParse(mask[0].attributes, []);
                const filters     = safeParse(mask[0].filters, []);
                const sorters     = safeParse(mask[0].sorters, []);
                const json_columns = safeParse(mask[0].columns, {});
                if (Array.isArray(attributes) && attributes.length > 1) {
                    table?.setColumnLayout?.(attributes);
                }
                if (restartRestore) {
                    restoreConfirmedFilters();
                } else if (Array.isArray(filters)) {
                    filters.forEach(f => table?.setHeaderFilterValue?.(f.field, f.value, true));
                }
                if (!restartRestore && Array.isArray(sorters) && sorters.length > 0) {
                    table?.setSort?.(sorters);
                }
                if (json_columns && typeof json_columns === "object") {
                    const merged = { ...CALIBRATION_COMPANY_CERT_STATE_LIST_DEFAULT_COLUMNS_VISIBLE, ...json_columns, id: true };
                    setColumnsVisible(merged);
                    for (let column in merged) {
                        if (merged[column] === false) table?.hideColumn?.(column);
                        else table?.showColumn?.(column);
                    }
                }
            } else if (restartRestore) {
                restoreConfirmedFilters();
            }
            tableBuiltRef.current = true;
            restartQueuedRef.current = false;
            window.setTimeout(() => {
              isRestoringRef.current = false;
              sessionQueryActiveRef.current = false;
            }, 0);
          },
          ...getTabulatorPersistLayoutEvents("CalibrationCompanyCertStateList", ref, setUserMaskFilter),
      }}
      options={{
        index: '_rowKey',
        layout: "fitColumns", renderHorizontal:"virtual", rowHeight:TABULATOR_AUDIT_MIN_ROW_HEIGHT, movableColumns: true,
      dataTree:true,dataTreeStartExpanded:false,dataTreeFilter:false,dataTreeElementColumn:"company.name",
      dataTreeCollapseElement:ReactDOMServer.renderToStaticMarkup(<CollapseTreeIcon/>),
      dataTreeExpandElement:ReactDOMServer.renderToStaticMarkup(<ExpandTreeIcon/>),
      dataTreeBranchElement:ReactDOMServer.renderToStaticMarkup(<BranchTreeIcon/>),
      ajaxURL: '/api/company_certificates/paged',
      ajaxRequestFunc,
      filterMode: 'remote',
      sortMode: 'remote',
      pagination: false,
      progressiveLoad: 'scroll',
      progressiveLoadScrollMargin: 80,
      progressiveLoadDelay: 200,
      paginationSize: pageSizePc,
      dataLoader: true,
      dataLoaderLoading: t('Common.LoadingData'),
      dataLoaderError: t('Common.LoadFailed'),
      ajaxRequesting: () => {
        if (pendingInvalidationRef.current && !isTableVisible()) return false;
        if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
        const table = getTable();
        if (table?.initialized) table.alert?.(t('Common.LoadingData'));
        return true;
      },
      ajaxResponse: (url, params, response) => {
        getTable()?.clearAlert?.();
        const next = applyCalibrationCertPagedMutationOverlay(response, mutationOverlayRef.current);
        if (next && typeof next === 'object') lastResponseRef.current = next;
        return next;
      },
      ajaxError: () => {
        getTable()?.clearAlert?.();
      },
      }}/>
    </div>
  </div>
</div>
</div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">

              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){
          if(index<2) return null;
                    return <div
                        key={index}
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    >

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>

                        {/* Use the React icon component */}
                    </div>
                })}
            <button onClick={() => {setUserMaskFilter("CalibrationCompanyCertStateList","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>

      </div>
        </>
    )
}